import React from "react";
import { useNavigate } from "react-router-dom";
import PageHeading from "../../../components/PageHeading";
import { Button } from "primereact/button";


const AdminHome = () => {
    const navigate = useNavigate();

    const activeFreeTrialsClicked = () => {
        navigate("/account/admin/free-trials");
    }

    const expiredFreeTrialsClicked = () => {
        navigate("/account/admin/expired-free-trials");
    }

    const subscriptionsClicked = () => {
        navigate("/account/admin/subscriptions");
    }

    const canceledSubscriptionsClicked = () => {
        navigate("/account/admin/canceled-subscriptions");
    }

    const promosClicked = () => {
        navigate("/account/admin/promos");
    }

    const allProvidersClicked = () => {
        navigate("/account/admin/all-providers");
    }

    const allProfilesClicked = () => {
        navigate("/account/admin/all-profiles");
    }

    const allUsersClicked = () => {
        navigate("/account/admin/all-users");
    }

    const userEventsClicked = () => {
        navigate("/account/admin/user-events");
    }

    const eventsClicked = () => {
        navigate("/account/admin/events");
    }
    const pageHeader = (
        <PageHeading pageTitle="Wallist Administration">
            <div className="block">
            </div>
        </PageHeading>
    );

    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                <div className="card mb-3">
                    <div className="text-2xl font-bold mb-0 pl-3 md:pl-5">
                        Subscriptions
                    </div>
                    <div className="grid text-center">
                        <div className="col-6 md:col-3 mb-0 px-2 sm:px-5">
                            <Button className="p-3 m-2" onClick={activeFreeTrialsClicked}>
                                <span style={{ fontSize: '1rem' }}>
                                    <i className="pi pi-calendar-plus text-2xl text-white-500"></i>
                                </span>
                            </Button>
                            <div className="text-900 font-medium">
                                <Button label="Active Free Trials" className='p-button-text m-0 p-0' onClick={activeFreeTrialsClicked} />
                            </div>
                            <span className="text-700 text-sm line-height-3">Prospects currently on a free trial</span>
                        </div>
                        <div className="col-6 md:col-3 mb-0 px-2 sm:px-5">
                            <Button className="p-3 m-2" onClick={expiredFreeTrialsClicked}>
                                <span style={{ fontSize: '1rem' }}>
                                    <i className="pi pi-calendar-minus text-2xl text-white-500"></i>
                                </span>
                            </Button>
                            <div className="text-900 font-medium">
                                <Button label="Expired Free Trials" className='p-button-text m-0 p-0' onClick={expiredFreeTrialsClicked} />
                            </div>
                            <span className="text-700 text-sm line-height-3">Trials that have ended</span>
                        </div>
                        <div className="col-6 md:col-3 mb-0 px-2 sm:px-5">
                            <Button className="p-3 m-2" onClick={subscriptionsClicked}>
                                <span style={{ fontSize: '1rem' }}>
                                    <i className="pi pi-calendar-clock text-2xl text-white-500"></i>
                                </span>
                            </Button>
                            <div className="text-900 font-medium">
                                <Button label="Subscriptions" className='p-button-text m-0 p-0' onClick={subscriptionsClicked} />
                            </div>
                            <span className="text-700 text-sm line-height-3">Customers on an active subscription</span>
                        </div>
                        <div className="col-6 md:col-3 mb-0 px-2 sm:px-5">
                            <Button className="p-3 m-2" onClick={canceledSubscriptionsClicked}>
                                <span style={{ fontSize: '1rem' }}>
                                    <i className="pi pi-calendar-times text-2xl text-white-500"></i>
                                </span>
                            </Button>
                            <div className="text-900 font-medium">
                                <Button label="Canceled Subscriptions" className='p-button-text m-0 p-0' onClick={canceledSubscriptionsClicked} />
                            </div>
                            <span className="text-700 text-sm line-height-3">Subscriptions that have been canceled</span>
                        </div>
                        <div className="col-6 md:col-3 mb-0 px-2 sm:px-5">
                            <Button className="p-3 m-2" onClick={promosClicked}>
                                <span style={{ fontSize: '1rem' }}>
                                    <i className="pi pi-tag text-2xl text-white-500"></i>
                                </span>
                            </Button>
                            <div className="text-900 font-medium">
                                <Button label="Promos" className='p-button-text m-0 p-0' onClick={promosClicked} />
                            </div>
                            <span className="text-700 text-sm line-height-3">Promotion Codes</span>
                        </div>
                    </div>
                </div>
                <div className="card mb-3">
                    <div className="text-2xl font-bold mb-0 pl-3 md:pl-5">
                        Miscellaneous
                    </div>
                    <div className="grid text-center">
                        <div className="col-6 md:col-3 mb-0 px-2 sm:px-5">
                            <Button className="p-3 m-2" onClick={allProvidersClicked}>
                                <span style={{ fontSize: '1rem' }}>
                                    <i className="pi pi-sitemap text-2xl text-white-500"></i>
                                </span>
                            </Button>
                            <div className="text-900 font-medium">
                                <Button label="Providers" className='p-button-text m-0 p-0' onClick={allProvidersClicked} />
                            </div>
                            <span className="text-700 text-sm line-height-3">All Providers</span>
                        </div>
                        <div className="col-6 md:col-3 mb-0 px-2 sm:px-5">
                            <Button className="p-3 m-2" onClick={allProfilesClicked}>
                                <span style={{ fontSize: '1rem' }}>
                                    <i className="pi pi-images text-2xl text-white-500"></i>
                                </span>
                            </Button>
                            <div className="text-900 font-medium">
                                <Button label="Profiles" className='p-button-text m-0 p-0' onClick={allProfilesClicked} />
                            </div>
                            <span className="text-700 text-sm line-height-3">All Profiles</span>
                        </div>
                        <div className="col-6 md:col-3 mb-0 px-2 sm:px-5">
                            <Button className="p-3 m-2" onClick={allUsersClicked}>
                                <span style={{ fontSize: '1rem' }}>
                                    <i className="pi pi-users text-2xl text-white-500"></i>
                                </span>
                            </Button>
                            <div className="text-900 font-medium">
                                <Button label="Users" className='p-button-text m-0 p-0' onClick={allUsersClicked} />
                            </div>
                            <span className="text-700 text-sm line-height-3">All Users</span>
                        </div>
                    </div>
                </div>
                <div className="card mb-3">
                    <div className="text-2xl font-bold mb-0 pl-3 md:pl-5">
                        Events
                    </div>
                    <div className="grid text-center">
                        <div className="col-6 md:col-3 mb-0 px-2 sm:px-5">
                            <Button className="p-3 m-2" onClick={userEventsClicked}>
                                <span style={{ fontSize: '1rem' }}>
                                    <i className="pi pi-history text-2xl text-white-500"></i>
                                </span>
                            </Button>
                            <div className="text-900 font-medium">
                                <Button label="User Events" className='p-button-text m-0 p-0' onClick={userEventsClicked} />
                            </div>
                            <span className="text-700 text-sm line-height-3">Search user activity</span>
                        </div>
                        <div className="col-6 md:col-3 mb-0 px-2 sm:px-5">
                            <Button className="p-3 m-2" onClick={eventsClicked}>
                                <span style={{ fontSize: '1rem' }}>
                                    <i className="pi pi-code text-2xl text-white-500"></i>
                                </span>
                            </Button>
                            <div className="text-900 font-medium">
                                <Button label="Events" className='p-button-text m-0 p-0' onClick={eventsClicked} />
                            </div>
                            <span className="text-700 text-sm line-height-3">View Mixpanel Events</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminHome;
